import React, { FC } from "react";
import { Box, BoxProps } from "theme-ui";

export const Navbar: FC<BoxProps> = ({ ...props }: BoxProps) => (
  <Box variant="boxes.header.navbar" {...props} />
);
